<template>
    <div class="section dark_grey">
        <div class="page-content">
            <div class="part">
                <div class="lexique">

                    <div class="titre-1">
                        Carte de localisation (présentée en page 1)
                    </div>

                    <div class="mapComponent" :class="{ no_edit: editor.mode != 'editing' }"
                        :style="{'z-index': editor.mode == 'editing' ? 10001 : 0}" style="margin-top:10px">
                        <MapComponent height="600" allow_ventes :allow_programs="false" allow_annotations linkedToView ref="bigMap" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import MapComponent from "../../elements/MapComponent.vue";
export default {
	components: { MapComponent },
	computed: {
		...mapGetters(["editor"]),

	},
	mounted () {
		this.$root.$on("scrollToBigMapGIE", () => this.$refs.bigMap.$el.scrollIntoView({ behavior: "smooth" }));
	},

};
</script>
<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';
@import '../../../../../assets/css/lexique';
</style>
